module.exports = {"detail":{"type":"grains","total":6,"data":"月平均價格"},"grains":{"grains_0":{"itemName":"落花生(帶殼)","fileName":"grains_0.csv","unit":"(元/公斤)"},"grains_1":{"itemName":"甘藷","fileName":"grains_1.csv","unit":"(元/公斤)"},"grains_2":{"itemName":"綠豆(省產)","fileName":"grains_2.csv","unit":"(元/公斤)"},"grains_3":{"itemName":"紅豆(中等)","fileName":"grains_3.csv","unit":"(元/公斤)"},"grains_4":{"itemName":"花生仁(總仁)","fileName":"grains_4.csv","unit":"(元/公斤)"},"grains_5":{"itemName":"大豆(黑豆)","fileName":"grains_5.csv","unit":"(元/公斤)"}}}


//////////////////
// WEBPACK FOOTER
// ./src/data/grains.json
// module id = 771
// module chunks = 0